import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ReactJWPlayer from 'react-jw-player';
import LiveCaptionOverlay from '../../Common/LiveCaptionOverlay';
import $ from 'jquery';
import playerInfoImage from '../../../../resources/console/images/jpg/player_info.png';
import useStore from '../../../../modules/utils/store';
import { toggleCssFullscreen, setupCssFullscreenListeners } from '../../../../modules/utils/cssFullscreen';
import { enableDefaultCaptions } from '../../jwCaptionDefaults';
const displayName = 'ReactJWPlayerContainer';
const propTypes = {
  playlist: PropTypes.array.isRequired,
  onMetaCallback: PropTypes.func.isRequired,
  onPlayCallback: PropTypes.func.isRequired,
  onPlayerDidMountCallback: PropTypes.func.isRequired,
  onPlayerUnMountCallback: PropTypes.func.isRequired,
  onTimeCallback: PropTypes.func.isRequired,
  onPauseCallback: PropTypes.func.isRequired,
  onResumeCallback: PropTypes.func.isRequired,
  onErrorCallback: PropTypes.func.isRequired,
  onSeekCallback: PropTypes.func.isRequired,
  onCompleteCallback: PropTypes.func.isRequired,
  onReadyCallback: PropTypes.func.isRequired,
  showSurveyButton: PropTypes.bool,
  onSurveyButtonClick: PropTypes.func,
}
var actionName = "";
let exitFullScreenAfterPlay = null;

// iOS 기기 감지 함수
const isIOSDevice = () => {
  // 전통적인 iOS 감지 (iPhone, iPad, iPod)
  const traditionalIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // 최신 iPad 감지 (iOS 13+에서 데스크톱 UserAgent 사용)
  const modernIPad = (
    navigator.maxTouchPoints && 
    navigator.maxTouchPoints > 2 && 
    /Mac/.test(navigator.platform)
  );
  
  return traditionalIOS || modernIPad;
};

// iOS 전용 스트림 모니터링 변수
let iosStreamMonitor = null;

class ReactJWPlayerContainer extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      siteInfo:props?.siteInfo,
      videoTitle: '',
      hasError: false,
      errorCode: null,
      isIOS: isIOSDevice(),
      cssFullscreen: useStore.getState().cssFullscreen,
      showFullscreenButton: false
    };

    this.lastTime = 0; // 마지막 재생 시간 추적

    this.onReady = this.onReady.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onEnterFullScreen = this.onEnterFullScreen.bind(this);
    this.onExitFullScreen = this.onExitFullScreen.bind(this);
    this.onMeta = this.onMeta.bind(this);
    this.onTime =  this.onTime.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onResume = this.onResume.bind(this);
    this.onError = this.onError.bind(this);
    this.onSeek = this.onSeek.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.handleCssFullscreenToggle = this.handleCssFullscreenToggle.bind(this);
    this.revealFullscreenButton = this.revealFullscreenButton.bind(this);
    this.handlePlayerMouseMove = this.handlePlayerMouseMove.bind(this);
    this.handlePlayerTouchStart = this.handlePlayerTouchStart.bind(this);

    // each instance of <ReactJWPlayer> needs a unique id.
    // we randomly generate it here and assign to the container instance.
    // this.playerId = someFunctionToRandomlyGenerateId();
    this.playerId = 'VYgkaoeG';
    this.bodyObserver = null;
    this.fullscreenButtonTimer = null;
  }

  componentWillUnmount(){
    console.log('jwplayer ', 'componentWillUnmount');

    // iOS 모니터링 정리
    if (iosStreamMonitor) {
      clearInterval(iosStreamMonitor);
      iosStreamMonitor = null;
    }
    
    // 공격적 HLS 타이머 정리
    if (this.aggressiveHLSTimer) {
      clearInterval(this.aggressiveHLSTimer);
      this.aggressiveHLSTimer = null;
    }
    
    // 모니터링 변수 정리
    this.finalErrorCount = 0;
    if (this.safeQuickCheck) {
      this.safeQuickCheck.idleCount = 0;
      this.safeQuickCheck.lastValidTime = 0;
      this.safeQuickCheck.hasPlayedEnough = false;
      this.safeQuickCheck.manifestFailCount = 0;
    }
    
    // onTime 시간 정체 변수 정리 (TypeA와 동일)
    this.timeStuckStart = null;
    this.timeStuckCount = 0;

    if (this.unsubscribeCssFullscreen) {
      this.unsubscribeCssFullscreen();
      this.unsubscribeCssFullscreen = null;
    }

    if (this.cleanupCssFullscreenListeners) {
      this.cleanupCssFullscreenListeners();
      this.cleanupCssFullscreenListeners = null;
    }

    if (this.bodyObserver) {
      this.bodyObserver.disconnect();
      this.bodyObserver = null;
    }

    if (this.videoAttrsObserver) {
      this.videoAttrsObserver.disconnect();
      this.videoAttrsObserver = null;
    }

    if (this.fullscreenButtonTimer) {
      clearTimeout(this.fullscreenButtonTimer);
      this.fullscreenButtonTimer = null;
    }

    if (this.cleanupDefaultCaptions) {
      this.cleanupDefaultCaptions();
      this.cleanupDefaultCaptions = null;
    }

    // 클릭 인터셉터 정리
    if (this.jwClickInterceptor) {
      const { el, fn } = this.jwClickInterceptor;
      el?.removeEventListener?.('click', fn, true);
      this.jwClickInterceptor = null;
    }

    this.props.onPlayerUnMountCallback();
  };

  componentDidMount(){
    console.log('jwplayer ', 'componentDidUnmount');
    this.cleanupCssFullscreenListeners = setupCssFullscreenListeners(
      () => useStore.getState().cssFullscreen,
      useStore.getState().setCssFullscreen
    );
    this.unsubscribeCssFullscreen = useStore.subscribe(state => {
      if (state.cssFullscreen !== this.state.cssFullscreen) {
        this.setState({ cssFullscreen: state.cssFullscreen });
      }
    });
    this.props.onPlayerDidMountCallback();
  }

  componentDidUpdate(prevProps) {
    if (this.props.forceError !== prevProps.forceError) {
      if (this.props.forceError) {
        // 채널 연결 해제(토글 OFF) → 즉시 재생 중단 및 에러 이미지 표시
        try {
          const player = window.jwplayer(this.playerId);
          if (player && player.stop) {
            player.stop();
          }
        } catch (e) {}
        this.setState({ hasError: true, errorCode: 'NO_CHANNEL' });
      } else {
        // 채널 연결(토글 ON)됐을 때 에러 해제
        this.setState({ hasError: false, errorCode: null });
      }
    }
  }

  onReady(event) {
    // interact with JW Player API here
    const player = window.jwplayer(this.playerId);
    this.cleanupDefaultCaptions = enableDefaultCaptions(player);

    // ────────────────────────────────────────────────────────────────
    // 클릭/더블클릭 가로채기:
    // JW Player 8은 `dblclick` 브라우저 이벤트가 아닌 `click` 이벤트를 자체 카운팅해
    // 더블클릭→native fullscreen 진입을 처리한다. 따라서 dblclick 인터셉트로는 막을 수 없음.
    // → capture phase에서 모든 click을 가로채 JW에게 도달 못하게 stopImmediatePropagation,
    //    우리가 직접 단일/더블 클릭을 300ms 윈도우로 판정해 처리한다.
    //   - 단일 클릭: JW API로 play/pause (300ms 후 확정)
    //   - 더블 클릭: CSS 하이브리드 fullscreen 토글
    // ────────────────────────────────────────────────────────────────
    const playerContainerEl = document.getElementById(this.playerId);
    if (playerContainerEl && !this.jwClickInterceptor) {
      let pendingSingleClickTimer = null;
      const onClick = (e) => {
        // 컨트롤바/디스플레이 아이콘/메뉴 등 JW Player 자체 UI 영역 클릭은 가로채지 않고
        // 라이브러리 자체 핸들러로 처리되도록 통과시킨다. 이 가드가 없으면 음소거/설정 등
        // 모든 컨트롤바 클릭이 단일/더블 click interceptor로 빠져 영상 play/pause 토글만 일어난다.
        if (e.target.closest && e.target.closest(
          '.jw-controlbar, .jw-display-icon-container, .jw-settings-menu, ' +
          '.jw-nextup-container, .jw-shortcuts-tooltip, .jw-float-bar, ' +
          '.jw-icon, .jw-icon-tooltip, .jw-overlay, .jw-slider-time'
        )) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }

        if (pendingSingleClickTimer) {
          clearTimeout(pendingSingleClickTimer);
          pendingSingleClickTimer = null;
          const isCssFullscreen = useStore.getState().cssFullscreen;
          this.handleCssFullscreenToggle(!isCssFullscreen);
          return;
        }

        pendingSingleClickTimer = setTimeout(() => {
          pendingSingleClickTimer = null;
          try {
            const p = window.jwplayer(this.playerId);
            const state = p.getState && p.getState();
            if (state === 'playing') {
              p.pause();
            } else {
              p.play(true);
            }
          } catch (err) {}
        }, 300);
      };
      playerContainerEl.addEventListener('click', onClick, true);
      this.jwClickInterceptor = { el: playerContainerEl, fn: onClick };
    }
    // ────────────────────────────────────────────────────────────────

    var heightvideo = $('.video_element').height();
    var detail_wrap = $('.detail_wrap').css('display');
    $('.video_pre_con').css("display", "none");
    
    $('.video_dummy').css('height', heightvideo + 'px');
    var video_dummyHeight = $('.video_dummy').height();
    $('.jw-overlays').css("opacity", "0");
    if (detail_wrap == "block") { 
      $(".detail_flex_box").addClass("detail_flex_box_1")
    } else {
      $(".detail_flex_box").removeClass("detail_flex_box_1")
    }
    
    // if (window.innerWidth <= 767) {
    //   $('.detail_flex_box').css('margin-top', heightvideo + 60 + 'px');
    // }

    // mobileMiniPlayerFixed는 handleResize/scrollEvent 양쪽에서 공유해야 하므로 외부 스코프로 뺀다.
    // (기존에는 handleResize 내부에 let으로 선언되어 scrollEvent에서 ReferenceError로 중단되던 버그)
    let mobileMiniPlayerFixed = false;
    let mobileMiniPlayerTriggerScrollTop = null;
    const mobileMiniPlayerReleaseGap = 80;

    // PC/태블릿 스타일 mini-player(.fixed) 트리거 범위를 iPhone 가로모드까지 포함.
    // Safari iPhone 가로(852) + Chrome iPhone 가로(734)가 모두 매치되도록 768→568로 확장.
    // mobile portrait만 별도로 .m_fixed 경로를 사용한다.
    const checkIsMobileView = () =>
      window.innerWidth <= 767 && window.innerHeight >= window.innerWidth;
    const checkIsWideLayout = () =>
      !checkIsMobileView() && window.innerWidth <= 1024 && window.innerWidth >= 568;

    // 창 크기가 변경될 때마다 호출되는 이벤트 리스너
    const handleResize = () => {
      if (useStore.getState().cssFullscreen) {
        $(".video_con").removeClass("fixed m_fixed attedanceFixed");
        $(".video_dummy").removeClass("on");
        $(".header, #header").removeClass("videofixed");
        return;
      }

      // 가로↔세로 회전 / 리사이즈 시 이전 모드에서 추가된 fixed/m_fixed가 잔존해
      // 다음 모드에서 미니 플레이어 전환이 깨지는 회귀 방지. 모든 fixed 상태를 일단 정리하고
      // 아래 layout-별 분기에서 새 viewport 기준으로 다시 결정한다.
      $(".video_con").removeClass("fixed m_fixed attedanceFixed");
      $(".video_dummy").removeClass("on");
      $(".header, #header").removeClass("videofixed");
      mobileMiniPlayerFixed = false;
      mobileMiniPlayerTriggerScrollTop = null;

      // 현재 화면의 가로 너비와 세로 높이를 가져옵니다.
      var screenWidth = window.innerWidth;
      var screenHeight = window.innerHeight;

      // 비율을 계산합니다.
      var aspectRatio = screenWidth / screenHeight;

      var heightvideo = $('.video_element').height();
      $('.video_dummy').css('height', heightvideo + 'px');
      var video_dummyHeight = $('.video_dummy').height();
    var detail_wrap = $('.detail_wrap').css('display');
    if (detail_wrap == "block") {
      $(".detail_flex_box").addClass("detail_flex_box_1")
    } else {
      $(".detail_flex_box").removeClass("detail_flex_box_1")
    }
      // if (window.innerWidth <= 767) {
      //   $('.detail_flex_box').css('margin-top', heightvideo + 60 + 'px');
      // } else {
      //   $('.detail_flex_box').css('margin-top','0px');
      // }
      // 여기에 콘솔 로그와 함께 원하는 동작을 추가할 수 있습니다.
      if (checkIsWideLayout()) {
        if (st + 60 >= video_scr) {
          $(".video_con").addClass("fixed");
          $(".video_dummy").addClass("on");
          $(".header").addClass("videofixed");
        } else {
          $(".video_con").removeClass("fixed");
          $(".video_dummy").removeClass("on");
          $(".header").removeClass("videofixed");
        }
      }
      if (window.innerWidth >= 1024 || detail_wrap == "flex") {
        $(".video_con").removeClass("fixed");
        $(".video_con").removeClass("m_fixed");
        $(".video_dummy").removeClass("on");
      }
    };

    const scrollEvent = () => { 
      if (useStore.getState().cssFullscreen) {
        $(".video_con").removeClass("fixed m_fixed attedanceFixed");
        $(".video_dummy").removeClass("on");
        $(".header, #header").removeClass("videofixed");
        mobileMiniPlayerFixed = false;
        return;
      }
      
      var st = $(document).scrollTop();
      var detail_wrap = $('.detail_wrap').css('display');
      var attendBox = $('.attend_box');
      if (detail_wrap == "block") { 
        $(".detail_flex_box").addClass("detail_flex_box_1")
      } else {
        $(".detail_flex_box").removeClass("detail_flex_box_1")
      }
      // 현재 화면의 가로 너비와 세로 높이를 가져옵니다.
      var screenWidth = window.innerWidth;
      var screenHeight = window.innerHeight;

      // 비율을 계산합니다.
      var aspectRatio = screenWidth / screenHeight;
      var sub_bg_img_hd = $('.sub_bg_img_hd').height();
      if ($(".detail_flex_box_1")) { 
        var video_scr = $(".detail_flex_box_1").offset().top;
      }
      
      if (attendBox.length > 0) {
        if (checkIsWideLayout()) {
          if (st + 82 >= video_scr) {
            $(".video_con").addClass("fixed");
            $(".video_con").addClass("attedanceFixed");
            $(".video_dummy").addClass("on");
            $("#header").addClass("videofixed");
          } else {
            $(".video_con").removeClass("fixed");
            $(".video_con").removeClass("attedanceFixed");
            $(".video_dummy").removeClass("on");
            $("#header").removeClass("videofixed");
          }
        }
      } else {
        if (checkIsWideLayout()) {
          if (st + 56 >= video_scr) {
            $(".video_con").addClass("fixed");
            $(".video_dummy").addClass("on");
            $("#header").addClass("videofixed");
          } else {
            $(".video_con").removeClass("fixed");
            $(".video_dummy").removeClass("on");
            $("#header").removeClass("videofixed");
          }
        }
      }




      if (checkIsMobileView()) {
        const triggerElement = $('.m_list_wrapper').get(0);
        const videoContainer = $('.video_con').get(0);

        if (!triggerElement || !videoContainer) {
          return;
        }

        // scrollY 기반 threshold 캐시 방식 (TypeA와 동일).
        // 기존 로직은 playerBottom(viewport 기준)을 매번 다시 계산했는데,
        // .m_fixed가 적용되면 player가 작아져 bottom이 변해 release 조건이 영영 만족되지 않는 버그가 있었음.
        // TypeB 포트레이트에서는 .video_con이 아니라 부모 .detail_wrap_con에 position: sticky; top: 82px이 있으므로
        // 그 ancestor의 top을 읽어야 docking point가 올바르게 계산된다.
        const triggerTop = triggerElement.getBoundingClientRect().top;
        const stickyAncestor = videoContainer.closest('.detail_wrap_con') || videoContainer;
        const stickyTop = parseFloat(window.getComputedStyle(stickyAncestor).top || "0") || 0;
        const triggerAbsoluteTop = window.scrollY + triggerTop;

        if (!mobileMiniPlayerFixed) {
          mobileMiniPlayerTriggerScrollTop = triggerAbsoluteTop - stickyTop;
        }

        const fixThreshold = mobileMiniPlayerTriggerScrollTop != null
          ? mobileMiniPlayerTriggerScrollTop
          : (triggerAbsoluteTop - stickyTop);
        const shouldFix = window.scrollY >= fixThreshold;
        const shouldRelease = window.scrollY < fixThreshold - mobileMiniPlayerReleaseGap;

        if (!mobileMiniPlayerFixed && shouldFix) {
          $('.video_con').addClass("m_fixed");
          mobileMiniPlayerFixed = true;
        } else if (mobileMiniPlayerFixed && shouldRelease) {
          $('.video_con').removeClass("m_fixed");
          mobileMiniPlayerFixed = false;
          mobileMiniPlayerTriggerScrollTop = null;
        }
      } else if (mobileMiniPlayerFixed) {
        $('.video_con').removeClass("m_fixed");
        mobileMiniPlayerFixed = false;
        mobileMiniPlayerTriggerScrollTop = null;
      }
    }
    // 창 크기 변경 이벤트 리스너 추가
    window.addEventListener('resize', handleResize);
    // orientationchange도 함께 등록 — 일부 브라우저는 회전 시 resize가 늦게/안 발생해
    // mode 전환이 누락되는 회귀가 있어 명시적으로 트리거한다.
    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('scroll', scrollEvent, { passive: true });

    // iOS에서 극단적 재시도 차단 + 즉시 에러 처리
    if (this.state.isIOS) {
      // iOS에서 JWPlayer 즉시 에러 처리
      player.on('error', (errorEvent) => {
        // 다른 모든 모니터링 정지
        if (iosStreamMonitor) {
          clearInterval(iosStreamMonitor);
          iosStreamMonitor = null;
        }
        this.onError(errorEvent);
      });

      player.on('setupError', (setupError) => {
        this.onError(setupError);
      });
      
    }

    // Samsung Internet 등 일부 모바일 브라우저는 페이지에 video 요소가 있으면 자체 fullscreen/PIP
    // 컨트롤 오버레이를 자동으로 띄운다. 우리는 커스텀 UI를 사용하므로 그 브라우저 UI를 차단해야 함.
    // 또한 Samsung Internet은 video 요소에 mouseover/touch만 있어도 어시스턴트 버튼을 띄우는 quirk가
    // 있어서 video 자체에 pointer-events:none을 걸어 hover/click을 video 까지 도달 못하게 한다.
    // (JW Player는 controls 오버레이를 별도 요소로 띄우므로 사용자 조작은 그대로 작동)
    const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent || '');
    const applyVideoSuppressAttrs = (el) => {
      if (!el) return;
      el.setAttribute('playsinline', 'true');
      el.setAttribute('webkit-playsinline', '');
      el.setAttribute('disablePictureInPicture', '');
      el.setAttribute('disableRemotePlayback', '');
      el.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
      if (isSamsungBrowser) {
        el.style.pointerEvents = 'none';
      }
    };
    applyVideoSuppressAttrs(document.querySelector('.video_con video'));

    // JW Player가 video 요소를 재생성하는 경우(스트림 전환 등)에도 속성이 유지되도록 observer로 보강
    const videoFrame = document.querySelector('.video_con .video-frame, .video_con .video_element');
    if (videoFrame && !this.videoAttrsObserver) {
      this.videoAttrsObserver = new MutationObserver(() => {
        videoFrame.querySelectorAll('video').forEach(applyVideoSuppressAttrs);
      });
      this.videoAttrsObserver.observe(videoFrame, { childList: true, subtree: true });
    }

    // 플레이 버튼 클릭 즉시 감지 (로딩 시작 전) → 채널 없으면 즉시 에러 이미지
    player.on('playAttempt', () => {
      if (this.props.forceError) {
        this.setState({ hasError: true, errorCode: 'NO_CHANNEL' });
      }
    });

    // 모달 오픈 시 video_con에 fixed 클래스가 추가되어 소형 플레이어로 전환되는 현상 방지
    this.bodyObserver = new MutationObserver(() => {
      if (document.body.classList.contains('modal-open')) {
        $(".video_con").removeClass("fixed m_fixed attedanceFixed");
        $(".video_dummy").removeClass("on");
        $(".header, #header").removeClass("videofixed");
        mobileMiniPlayerFixed = false;
      }
    });
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    this.props.onReadyCallback(player);

  }

  onAdPlay(event) {
    // track the ad play here
  }
  onVideoLoad(event) {
    this.setState({
      videoTitle: event.item.description // this only works with json feeds!
    });

    console.log("jwplayer : ", `onVideoLoad..: event : ${event.status}`);
  }
  onResume(event) {
    console.log("jwplayer : ", "onResume : "+ event.position);

    this.setState({
      hasError: false,
      errorCode: event.code
    });

    this.props.onResumeCallback(event);
    
  }
  handleCssFullscreenToggle(enter) {
    toggleCssFullscreen(enter, useStore.getState().setCssFullscreen);
  }

  revealFullscreenButton() {
    if (!this.state.cssFullscreen) {
      return;
    }

    this.setState({ showFullscreenButton: true });

    if (this.fullscreenButtonTimer) {
      clearTimeout(this.fullscreenButtonTimer);
    }

    this.fullscreenButtonTimer = setTimeout(() => {
      this.setState({ showFullscreenButton: false });
      this.fullscreenButtonTimer = null;
    }, 2000);
  }

  handlePlayerMouseMove() {
    this.revealFullscreenButton();
  }

  handlePlayerTouchStart() {
    this.revealFullscreenButton();
  }
  onEnterFullScreen(event) {
    console.log("jwplayer : ", "onEnterFullScreen......................");
    try {
      window.jwplayer(this.playerId).setFullscreen(false);
    } catch (e) {}
    this.handleCssFullscreenToggle(true);
  }
  onExitFullScreen(event) {
    console.log("jwplayer : ", "onExitFullScreen......................");
    exitFullScreenAfterPlay = setInterval(() => {
      console.log('play interval')
      window.jwplayer(this.playerId).play(true);
    },1000);
  }
  onPause(event){
    // console.log("jwplayer : ", "onPause : " + event.position);
    
    // iOS에서 pause 체크 비활성화 (오탐 방지)
    if (this.state.isIOS) {
      return;
    }
    
    this.props.onPauseCallback(event);
  }
  onTime(event){
    clearInterval(exitFullScreenAfterPlay); //전체화면해제 후 강제 플레이 interval clear
    
    const currentTime = event.currentTime || 0;
    
    // iOS 빠른 감지 시스템
    if (this.state.isIOS) {
      // 시간이 0으로 떨어진 경우 빠른 감지
      if (currentTime === 0 && this.lastTime > 8) {
        setTimeout(() => {
          const recheckTime = window.jwplayer(this.playerId).getPosition();
          if (recheckTime === 0) {
            this.onError({ code: 'IOS_TIME_DROP', message: 'iOS time drop to 0 detected' });
            return;
          }
        }, 1000);
      }
      
      // 시간 정체 감지
      if (this.lastTime >= 12 && currentTime === this.lastTime && currentTime > 0) {
        if (!this.timeStuckStart) {
          this.timeStuckStart = Date.now();
          this.timeStuckCount = 0;
        } else if (Date.now() - this.timeStuckStart >= 4000) {
          this.timeStuckCount++;
          if (this.timeStuckCount >= 3) {
            setTimeout(() => {
              const recheckTime = window.jwplayer(this.playerId).getPosition();
              if (recheckTime === this.lastTime) {
                this.onError({ code: 'IOS_TIME_STUCK', message: 'iOS time stuck detected' });
                return;
              }
            }, 1000);
          }
        }
      } else {
        this.timeStuckStart = null;
        this.timeStuckCount = 0;
      }
    }
    
    this.lastTime = currentTime;
    
    this.props.onTimeCallback(event);
  }
  onSeek(event){
    // console.log("jwplayer : ", "onSeek : " + event.position);
    this.props.onSeekCallback(event);
  }

  onError(event){

    if (event.code) { 
      this.setState({ 
        hasError: true,
        errorCode: event.code
      });

      $('.jw-error-msg .jw-icon, .jw-error-msg .jw-error-text ,.jw-error-msg .jw-info-container').remove();
      
    }

    this.props.onErrorCallback(event);
  }

  onPlay(event) {
    console.log("jwplayer : ", "onPlay : " + event);
    console.log("jwplayer : ", "this props : " + this.props);

    // forceError가 true면 즉시 에러 이미지 표시 (채널 미선택 상태)
    if (this.props.forceError) {
      this.setState({ hasError: true, errorCode: 'NO_CHANNEL' });
      this.props.onPlayCallback(event);
      return;
    }

    // 재송출 시 에러 상태 리셋
    if (this.state.hasError) {

      this.setState({
        hasError: false,
        errorCode: null
      });
    }
    
    // iOS에서 하이브리드 감지 변수 리셋 (TypeA와 동일)
    if (this.state.isIOS && this.safeQuickCheck) {
      this.safeQuickCheck.idleCount = 0;
      this.safeQuickCheck.lastValidTime = 0;
      this.safeQuickCheck.hasPlayedEnough = false;
      this.safeQuickCheck.manifestFailCount = 0;
      this.finalErrorCount = 0;
      
      // onTime 시간 정체 감지 변수 리셋
      this.timeStuckStart = null;
      this.timeStuckCount = 0;
    }
    
    // iOS에서 스트림 모니터링 시작
    if (this.state.isIOS) {
      this.startIOSStreamMonitoring();
    }
    
    this.props.onPlayCallback(event);
  }
  onMeta(meta){
    // console.log("jwplayer : ", "onMeta");
    this.props.onMetaCallback(meta);
  }
  onComplete(event){
    // iOS 모니터링 정리
    if (iosStreamMonitor) {
      clearInterval(iosStreamMonitor);
      iosStreamMonitor = null;
    }
    
    if (this.aggressiveHLSTimer) {
      clearInterval(this.aggressiveHLSTimer);
      this.aggressiveHLSTimer = null;
    }
    
    // onTime 시간 정체 변수 정리 (TypeA와 동일)
    this.timeStuckStart = null;
    this.timeStuckCount = 0;

    this.props.onCompleteCallback(event)
  }

  // iOS 전용 극단적으로 단순한 모니터링 (오탐 완전 방지)
  startIOSStreamMonitoring() {
    // 기존 모니터링 정리
    if (iosStreamMonitor) {
      clearInterval(iosStreamMonitor);
    }
    
    // 단순 변수만 유지
    this.finalErrorCount = 0;
    
    // 하이브리드 전략: 다중 빠른 감지 + JWPlayer 백업
    
    // 안전한 빠른 감지용 변수
    this.safeQuickCheck = {
      idleCount: 0,           // idle 상태 카운트
      lastValidTime: 0,       // 마지막 유효 재생 시간
      hasPlayedEnough: false, // 충분히 재생했는지 (10초 이상)
      manifestFailCount: 0    // HLS manifest 실패 카운트
    };
    
    // HLS Manifest 직접 체크 (빠른 감지)
    const player = window.jwplayer(this.playerId);
    const playlist = player.getPlaylist();
    const manifestUrl = playlist && playlist[0] && playlist[0].sources[0] && playlist[0].sources[0].file;
    
    if (manifestUrl) {
      const ultraFastHLSCheck = () => {
        if (this.safeQuickCheck.hasPlayedEnough) {
          Promise.race([
            fetch(manifestUrl, { method: 'HEAD', cache: 'no-cache' }),
            new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 2000))
          ])
          .then(response => {
            if (!response.ok && response.status >= 400) {
              this.safeQuickCheck.manifestFailCount++;
              
              if (this.safeQuickCheck.manifestFailCount >= 2) {
                this.onError({ code: 'ULTRA_HLS_FAIL', message: 'Ultra fast HLS failed' });
              }
            } else {
              this.safeQuickCheck.manifestFailCount = 0;
            }
          })
          .catch(() => {
            this.safeQuickCheck.manifestFailCount++;
            if (this.safeQuickCheck.manifestFailCount >= 2) {
              this.onError({ code: 'ULTRA_HLS_NETWORK', message: 'Ultra fast HLS network failed' });
            }
          });
        }
      };
      
      this.aggressiveHLSTimer = setInterval(ultraFastHLSCheck, 2000);
    }
    
    // 하이브리드 모니터링 (빠른 감지 + JWPlayer error 백업)
    iosStreamMonitor = setInterval(() => {
      const player = window.jwplayer(this.playerId);
      if (player && player.getState) {
        const state = player.getState();
        const position = player.getPosition();

        // 재생 시간 체크
        if (this.lastTime > 8) {
          this.safeQuickCheck.hasPlayedEnough = true;
          this.safeQuickCheck.lastValidTime = Math.max(this.safeQuickCheck.lastValidTime, position);
        }
        
        // 확실한 종료 상황에서 빠른 감지
        if (this.safeQuickCheck.hasPlayedEnough && 
            state === 'idle' && 
            position === 0 && 
            this.safeQuickCheck.lastValidTime > 5) {
          
          this.safeQuickCheck.idleCount++;
          if (this.safeQuickCheck.idleCount >= 2) {
            clearInterval(iosStreamMonitor);
            iosStreamMonitor = null;
            this.onError({ code: 'ULTRA_SAFE_QUICK', message: 'Ultra safe quick stream end detected' });
            return;
          }
        } 
        // JWPlayer error 백업 처리
        else if (state === 'error') {
          this.finalErrorCount++;
          if (this.finalErrorCount >= 2) {
            clearInterval(iosStreamMonitor);
            iosStreamMonitor = null;
            this.onError({ code: 'JWPLAYER_ERROR_BACKUP', message: 'JWPlayer error confirmed' });
            return;
          }
        } 
        // 정상 상태에서 카운터 리셋
        else if (state === 'playing' && position > 0) {
          this.safeQuickCheck.idleCount = 0;
          this.safeQuickCheck.manifestFailCount = 0;
          this.finalErrorCount = 0;
        }
      }
    }, 3000);
    
    // 플레이 시작 시간 기록
    this.playStartTime = Date.now();
  }

  render() {
    const { hasError, errorCode, cssFullscreen, showFullscreenButton } = this.state;
    const { showSurveyButton, onSurveyButtonClick } = this.props;
    return (
      <div
        className='react-jw-player-container'
        style={{position:'relative'}}
        onMouseMove={this.handlePlayerMouseMove}
        onTouchStart={this.handlePlayerTouchStart}
      >
        {hasError && (errorCode) && (
          <img
            style={{position:"absolute", top:"0", left:"0", zIndex:"100", display:"block", margin:'0 auto', width:"100%"}}
            src={playerInfoImage}
            alt="에러이미지"
          />
        )}
        <h1>{ this.state.videoTitle }</h1>
        {/* G14: 운영자 시점 라이브 자막 오버레이 — .react-jw-player-container 하위 정적 마운트 */}
        <LiveCaptionOverlay eventIdx={this.props.eventIdx} sessionIdx={this.props.sessionIdx} />
        <ReactJWPlayer
          playlist={this.props.playlist}
          onReady={this.onReady}
          onVideoLoad={this.onVideoLoad}
          onPlay={this.onPlay}
          onSeek={this.onSeek}
          onMeta={this.onMeta}
          onResume={this.onResume}
          onPause={this.onPause}
          onExitFullScreen={this.onExitFullScreen}
          onEnterFullScreen={this.onEnterFullScreen}
          onTime={this.onTime}
          onComplete={this.onComplete}
          onError={this.onError}
          playerId={this.playerId} // bring in the randomly generated playerId
          playerScript='https://cdn.jwplayer.com/libraries/VYgkaoeG.js'
          isAutoPlay={false}
          config={this.state.isIOS ? {
            // iOS 전용 극단적 재시도 차단 설정
            preload: 'none',
            hlsConfig: {
              maxRetry: 0,
              maxRetryDelay: 0,
              retryDelayOnFailure: 0,
              maxLoadingTimeout: 3000,
              enableWorker: false,
              fragLoadingTimeOut: 5000,
              levelLoadingTimeOut: 5000,
              manifestLoadingTimeOut: 5000
            },
            setupConfig: {
              retries: 0,
              retryInterval: 0,
              connectionTimeout: 3000,
              networkTimeout: 2000
            }
          } : this.props.forceError ? {
            // 유효한 스트림 없음 → 플레이 클릭 시 빠르게 에러 처리 (재시도 없이 3초 타임아웃)
            hlsConfig: {
              manifestLoadingTimeOut: 3000,
              manifestLoadingMaxRetry: 0,
              manifestLoadingRetryDelay: 0,
              fragLoadingTimeOut: 3000,
              fragLoadingMaxRetry: 0,
              levelLoadingTimeOut: 3000,
              levelLoadingMaxRetry: 0,
            }
          } : undefined}
        />
        {cssFullscreen && showSurveyButton && (
          <button
            type='button'
            className='css-fullscreen-survey-btn'
            onClick={onSurveyButtonClick}
            title='SURVEY'
          >
            SURVEY
          </button>
        )}
        <button
          type='button'
          className={`css-fullscreen-btn${showFullscreenButton ? ' is-visible' : ''}`}
          onClick={() => this.handleCssFullscreenToggle(!cssFullscreen)}
          title={cssFullscreen ? '전체화면 해제' : '전체화면'}
        >
          {cssFullscreen
            ? <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
            : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
          }
        </button>
      </div>
    );
  }
}
ReactJWPlayerContainer.propTypes = propTypes;
// ReactJWPlayerContainer.defaultProps = defaultProps;
ReactJWPlayerContainer.displayName = displayName;
export default ReactJWPlayerContainer;
